import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser } from "../../lib/api";

function Logs({ title }) {
  const user = readUser();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <AdminLayout user={user} active={title}>
      <section className="admin-panel">
        <div className="admin-panel-title"><div><span className="eyebrow">DENETİM</span><h2>{title}</h2></div></div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Zaman</th><th>Aktör</th><th>Eylem</th><th>Hedef</th><th>Meta</th></tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} data-testid={`admin-log-${i}`}>
                  <td>{new Date(r.at).toLocaleString("tr-TR")}</td>
                  <td>{r.actor}</td>
                  <td>{r.action}</td>
                  <td className="hash">{(r.target || "").slice(0, 20)}</td>
                  <td className="hash">{JSON.stringify(r.meta || {}).slice(0, 60)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!rows.length && <div className="table-empty">Henüz log kaydı yok.</div>}
        </div>
      </section>
    </AdminLayout>
  );
}

export const AdminSecurity = () => <Logs title="Güvenlik" />;
export const AdminLogs = () => <Logs title="Sistem Logları" />;
